<div class="ion-padding">
  @if (loading || addingMethod) {
    <div class="ion-text-center">
      <ion-spinner name="dots"></ion-spinner>
    </div>
  }

  @if (!addingMethod) {
    <div id="dropin"></div>
  }
  @if (
    (!loading && selectedMethod && selectedMethod !== 'paypal') ||
    addingMethod
    ) {
    <ion-button
      class="submit-button"
      (click)="addPayment()"
      expand="block"
      [disabled]="!validPayment"
      type="submit">
      {{ 'AUTH.REGISTER_PAYMENT' | translate }}
    </ion-button>
  }

  <div class="ion-text-center ion-padding-top">
    <a
      href="https://www.braintreegateway.com/merchants/2b8tv22q2hkjsrtd/verified"
      target="_blank">
      <img
        src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png"
        width="280px"
        height="44px"
        border="0" />
    </a>
  </div>
  @if (authPage) {
    <ion-button
      expand="block"
      fill="clear"
      class="ion-margin-top"
      (click)="doSkip()">
      {{ 'AUTH.SKIP' | translate }}
    </ion-button>
  }
</div>
